module.exports = __webpack_public_path__ + "static/media/df_logo.976f7ea6.svg";